import { render, staticRenderFns } from "./VehicleGearbox.vue?vue&type=template&id=8a983418&"
import script from "./VehicleGearbox.vue?vue&type=script&lang=js&"
export * from "./VehicleGearbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports